import React from 'react';
import { Spin } from 'antd';

interface AsyncReceiptsProps {
	isDelinquent?: boolean;
}

const LazyReceipts = React.lazy(() => import('./Receipts'));
export const AsyncReceiptsPage: React.FC<AsyncReceiptsProps> = ({ isDelinquent }) => (
	<React.Suspense fallback={<Spin />}>
		<LazyReceipts isDelinquent={isDelinquent} />
	</React.Suspense>
);
